import { useMemo } from 'react';
import { extractSelectedUnitIdsFromCards } from 'utils/AICardPanelHelper';

import type { IUseAICardPanelSelectedUnitIdsParams } from '../interfaces/IUseAICardPanelSelectedUnitIdsParams';

const useAICardPanelSelectedUnitIds = ({
  selectedCards,
}: IUseAICardPanelSelectedUnitIdsParams): number[] => (
  useMemo(
    () => extractSelectedUnitIdsFromCards(selectedCards),
    [selectedCards],
  )
);

export default useAICardPanelSelectedUnitIds;
